import { Outlet } from 'react-router-dom';
import { useState, useEffect } from 'react';
import useRefreshToken from '../api/useRefreshToken';
import useAuth from '../context/useAuth';

const PresistLogin = () => {
    const [isLoading, setIsLoading] = useState(true);
    const refresh = useRefreshToken();
    const { auth } = useAuth();

    useEffect(() => {

        const verifyRefreshToken = async () => {
            try {
                await refresh();
            } catch (err) {
                console.log(err)
            }
            finally {
                setIsLoading(false)
            }
        }
        !auth?.accessToken ? verifyRefreshToken() : setIsLoading(false);
    }, [])

   
    return (
        <>
            {isLoading ?
                <p>Loading...</p> : <Outlet />
            }
        </>
    );
};

export default PresistLogin;

